import { useRouter, useRuntimeConfig } from "#app";
import { useAuthStore } from "~/store/auth";
import { useClient } from "~/composables/useClient";

const catch_handler = async (error: any) => {
	if (process.client && error.response && error.response.status === 401 && error.response.statusText === "Unauthorized") {
		const router = useRouter();
		const auth = useAuthStore();
		auth.clear();
		if (window.location.toString().indexOf("checkout") > -1) {
			await router.push("/checkout/personal-data");
		} else if (window.location.toString().indexOf("login") === -1) {
			await router.push("/minha-area/login");
		}
	}

	if (error.response && error.response._data && error.response._data.statusCode != 500) {
		throw error.response._data
	}

	if (error.response && error.response._data) {
		let reference = "";
		if (error.request) {
			reference = error.request;
		}
		const payload = error.response._data;
		usePost("/core/error", { payload: JSON.stringify(payload), reference });
	}

	throw {message: "não foi possivel processar a sua solicitação, entre em contato com o atendimento ou tente novamente."};
};

let data: any = {
	get: {},
};

let reuse: any = {
	get: {}
};

export const useCachedGet = async (uri: string, opts = { signal: null }): Promise<any> => {
	// Only cache on client side, to prevent memory leak
	if (process.client) {
		// There is a cached response for this request? if there is use it
		if (data.get[uri]) return data.get[uri];
		// Wait for the reusable request
    const response = await useGet(uri, opts);
		// Save response on cache
		data.get[uri] = response;
		return response;
	}
	return useGet(uri, opts);
};

export const useGet = async (uri: string, opts: any = { signal: null }): Promise<any> => {
	const runtimeConfig = useRuntimeConfig();

	const url = uri.indexOf("http") > -1 ? uri : runtimeConfig.baseUrlApi + uri;
	let header = {};
	useClient(() => {
		const auth = useAuthStore();
		header = auth.getHeader();
	})
	return $fetch(url, {
		...opts,
		headers: {
			...(opts.headers || {}),
			...header,
		},
	});
};

export const usePost = (uri: string, payload: any = null, headers = {}): any => {
	const runtimeConfig = useRuntimeConfig();
	const url = uri.indexOf("http") > -1 ? uri : runtimeConfig.baseUrlApi + uri;
	let header = {};
	useClient(() => {
		const auth = useAuthStore();
		header = auth.getHeader();
	});
	return $fetch(url, {
		method: "POST",
		body: payload,
		headers: {
			...header,
			...headers,
		},
	}).catch(catch_handler);
};

export const usePatch = (uri: string, payload: any = null): any => {
	const runtimeConfig = useRuntimeConfig();
	let header = {};
	useClient(() => {
		const auth = useAuthStore();
		header = auth.getHeader();
	})
	return $fetch(runtimeConfig.baseUrlApi + uri, {
		method: "PATCH",
		body: payload,
		headers: {
			...header,
		},
	}).catch(catch_handler);
};

export const usePut = (uri: string, payload: any = null, headers = {}): any => {
	const runtimeConfig = useRuntimeConfig();
	const url = uri.indexOf("http") > -1 ? uri : runtimeConfig.baseUrlApi + uri;
	let header = {};
	useClient(() => {
		const auth = useAuthStore();
		header = auth.getHeader();
	});
	return $fetch(url, {
		method: "PUT",
		body: payload,
		headers: {
			...header,
			...headers,
		},
	}).catch(catch_handler);
};
